/**
 * Retourne true si la catégorie a au moins un item (direct ou dans un descendant).
 * Utilisé pour masquer les catégories entièrement vides dans /previsionnels.
 */
export function hasAnyForecast(cat) {
  if ((cat.items?.length ?? 0) > 0) return true;
  return (cat.children ?? []).some(hasAnyForecast);
}

/**
 * Somme récursive des total_monthly_cents d'une catégorie et de tous ses descendants.
 * Prend en compte les items directs via monthly_equivalent_cents si total_monthly_cents absent.
 */
export function sumCategoryMonthlyCents(category) {
  if (!category) return 0;
  // Si la catégorie a un total agrégé fiable renvoyé par le backend, on l'utilise.
  if (category.total_monthly_cents != null) return category.total_monthly_cents;
  // Sinon on somme récursivement : items directs + enfants
  let sum = 0;
  if (Array.isArray(category.items)) {
    for (const item of category.items) {
      sum += item.monthly_equivalent_cents ?? 0;
    }
  }
  if (Array.isArray(category.children)) {
    for (const child of category.children) {
      sum += sumCategoryMonthlyCents(child);
    }
  }
  return sum;
}

/**
 * À partir du tableau flows renvoyé par useForecastTree,
 * calcule la somme mensuelle par flow_type.
 * Retourne { expense: number, income: number, balance: number } (en centimes).
 */
export function sumFlowsMonthlyCents(flows) {
  if (!Array.isArray(flows)) return { expense: 0, income: 0, balance: 0 };
  let expense = 0;
  let income = 0;
  for (const flow of flows) {
    const categories = flow.categories ?? [];
    const flowSum = categories.reduce((acc, cat) => acc + sumCategoryMonthlyCents(cat), 0);
    if (flow.flow_type === 'expense') {
      expense += flowSum;
    } else if (flow.flow_type === 'income') {
      income += flowSum;
    }
  }
  return { expense, income, balance: income + expense };
}
